"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Label = _interopRequireDefault(require("../../elements/Label"));

var _Tooltip = _interopRequireDefault(require("../../elements/Tooltip"));

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Description of the Option component
 */
var Option = function Option(_ref) {
  var className = _ref.className,
      id = _ref.id,
      name = _ref.name,
      Tag = _ref.tag,
      label = _ref.label,
      labelProps = _ref.labelProps,
      tooltip = _ref.tooltip,
      tooltipProps = _ref.tooltipProps,
      type = _ref.type,
      cssModule = _ref.cssModule,
      _helpText = _ref.helpText,
      attrs = _objectWithoutProperties(_ref, ["className", "id", "name", "tag", "label", "labelProps", "tooltip", "tooltipProps", "type", "cssModule", "helpText"]);

  var classes = (0, _mapToCssModules.default)((0, _classnames.default)(className, 'option'), cssModule);
  return /*#__PURE__*/_react.default.createElement(Tag, {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    id: id,
    name: name,
    type: type
  }, attrs)), (label || tooltip) && /*#__PURE__*/_react.default.createElement(_Label.default, _extends({
    htmlFor: id
  }, labelProps), label, tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, _extends({
    id: "".concat(id, "__tooltip")
  }, tooltipProps), tooltip)));
};

Option.defaultProps = {
  className: undefined,
  type: 'checkbox',
  tag: 'div',
  label: undefined,
  labelProps: {},
  tooltip: undefined,
  tooltipProps: {},
  cssModule: undefined,
  helpText: undefined
};
Option.propTypes = {
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,

  /**
   * A description of the prop, it will automatically appear in the docs
   */
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(['radio', 'checkbox']),
  tag: _propTypes.default.string,

  /**
   * The content of the label
   */
  label: _propTypes.default.node,

  /**
   * Any extra props to be passed to the <Label />. See the Label docs for a list of options
   */
  labelProps: _propTypes.default.object,

  /**
   * The content of the tooltip
   */
  tooltip: _propTypes.default.node,

  /**
   * Any extra props to be passed to the <Tooltip />. See the Tooltip docs for a list of options
   */
  tooltipProps: _propTypes.default.object,
  cssModule: _propTypes.default.object,

  /**
   * Help text to display below the field.
   */
  helpText: _propTypes.default.node
};
var _default = Option;
exports.default = _default;
//# sourceMappingURL=Option.js.map